import { render, staticRenderFns } from "./TaskAddForm.vue?vue&type=template&id=aa0d402e&scoped=true&lang=pug&"
import script from "./TaskAddForm.vue?vue&type=script&lang=js&"
export * from "./TaskAddForm.vue?vue&type=script&lang=js&"
import style0 from "./TaskAddForm.vue?vue&type=style&index=0&id=aa0d402e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0d402e",
  null
  
)

export default component.exports